import React from 'react';
import InputAdornment from '@material-ui/core/InputAdornment';

import NumberFormatInput from './NumberFormatInput';

interface PhoneNumberInputProps {
  onChange?: (event: any) => void;
  onKeyPress?: (event: any) => void;
  onKeyUp?: (event: any) => void;
  onBlur?: (event: any) => void;
  pattern?: string;
  format?: string;
  readOnly?: boolean;
  disabled?: boolean;
  value?: string;
  autoFocus?: boolean;
  error: boolean;
}

const PhoneNumberInput = (props: PhoneNumberInputProps) => {
  const { onChange, onKeyPress, onKeyUp, pattern, format, readOnly, disabled, value, autoFocus, error, ...other } = props;

  return (
    <NumberFormatInput
      onChange={onChange}
      onKeyPress={onKeyPress}
      onKeyUp={onKeyUp}
      pattern={pattern}
      format={format}
      readOnly={readOnly}
      disabled={disabled}
      value={value}
      autoFocus={autoFocus}
      startAdornment={<InputAdornment position='start'>+61</InputAdornment>}
      type='tel'
      error={error}
      {...other}
    />
  );
};

export default PhoneNumberInput;
